var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("iframe", {
    staticClass: "youtube-video",
    attrs: {
      allow:
        "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      allowfullscreen: "",
      frameborder: "0",
      src:
        "https://www.youtube.com/embed/" +
        _vm.src +
        "?version=3&loop=1&rel=0&showinfo=0&modestbranding=1"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }